import type { GetRequestedCompanyResponse } from "../../types/admin";
import type { PageableRequest } from "../../types/shared";
import type { AdminRepository } from "../../repositories/admin/admin-repository";
import { AppError } from "../../../shared/utils/error-handler";
import type { CompanyDetailResponse } from "../../../shared/types/api";

export class AdminUseCase {
  constructor(private adminRepository: AdminRepository) {}

  async cancelRequestedCompany(companyAdminId: number): Promise<boolean> {
    try {
      return await this.adminRepository.cancelRequestedCompany(companyAdminId);
    } catch (error) {
      throw new AppError(
        String(error) || "업체 신청을 거절하지 못했습니다.",
        "REQUESTED_COMPANY_CANCEL_FAILED",
        error
      );
    }
  }

  async approveCompany(companyAdminId: number): Promise<boolean> {
    try {
      return await this.adminRepository.approveCompany(companyAdminId);
    } catch (error) {
      throw new AppError(
        String(error) || "업체 요청을 수락하지 못했습니다.",
        "COMPANY_APPROVE_FAILED",
        error
      );
    }
  }

  async getCompanyInfo(companyId: number): Promise<CompanyDetailResponse> {
    try {
      return await this.adminRepository.getCompanyInfo(companyId);
    } catch (error) {
      throw new AppError(
        String(error) || "업체 정보를 불러오지 못했습니다.",
        "COMPANY_INFO_GET_FAILED",
        error
      );
    }
  }

  async getRequestedCompany(
    pageable: PageableRequest
  ): Promise<GetRequestedCompanyResponse> {
    try {
      return await this.adminRepository.getRequestedCompany(pageable);
    } catch (error) {
      throw new AppError(
        String(error) || "요청된 업체들을 불러오지 못했습니다.",
        "REQUESTED_COMPANY_GET_FAILED",
        error
      );
    }
  }
}
